module.exports = __webpack_public_path__ + "img/bg_resize_castle_mist.1121ce72.png";